'use client'

import { useEffect, useRef, useState } from "react"
import styles from './ua.module.scss'
import Button from "../button/Button"
import Dropdown from "../dropdown/Dropdown"
import Form from "../form/Form"
import Icon from "../icon/Icon"
import { VEHICLE_TYPES } from "./FiltersComponent"
import StackedPanel from "../panel/StackedPanel"
import PanelBody from "../panel/PanelBody"
import PanelFooter from "../panel/PanelFooter"

export default function VehicleTypeButton(props) {
  
  const [selected,setSelected] = useState([])
  
  const ddBrands = useRef()

  useEffect(() => {
    if (props.filters.body) {
      if (Array.isArray(props.filters.body)) {
        setSelected(props.filters.body)
      } else {
        setSelected(props.filters.body.split(","))
      }
    }
  }, [])
  
  const toggle = (e) => {
    if (e) e.preventDefault()
    ddBrands.current.toggle()
  }
  
  const isSelected = (brand) => {
    return selected.indexOf(brand) >= 0
  }
  
  const onItemToggle = (e, item) => {
    const list = [...selected]
    if (list.indexOf(item) >= 0) {
      list.splice(list.indexOf(item), 1)
    } else {
      list.push(item)
    }
    setSelected(list)
  }
  
  const clear = (e) => {
    setSelected([])
    props.listingRef.current.applyFilters({ body: [] })
    toggle(e)
  }
  
  const onSubmit = (e) => {
    props.listingRef.current.applyFilters({ body: selected })
    toggle(e)
  }
  
  return <>
    <Button theme={["filter-icon", (selected.length > 0 ? 'filter-on' : '')]} onClick={e => toggle(e) } label={"More Body Types"}>
      <Icon {...props} name="veh-type-more"></Icon>
      <span>{ 'More' }</span>
    </Button>
    <Dropdown {...props} key="veh-type-more" ref={ddBrands} position={'right'} body={'padded'} offset={'12px'} title="Filter by Body Type">
      <Form id="veh_type_picker" name="Vehicle Type Picker" onSubmit={e => onSubmit(e)}>
        <StackedPanel>
          <PanelBody padded={true}>
            <div className={styles.br}>
              { props.site.vehicleTypes.filter(e => !props.site.inventory.topFilters?.vehicleTypes?.includes(e)).map(b => (
                <div key={b} className={ styles.bri }>
                  <Button theme={["gray-light-hover", isSelected(b) ? "filter-on" : "transparent", "filter-opt", "inline"]} label={ VEHICLE_TYPES[b] } onClick={e => onItemToggle(e, b)}></Button>
                </div>
              ))}
            </div>
          </PanelBody>
          <PanelFooter>
            <div className="flex-row flex-with-gap flex-full">
            <div className="flex-col flex-stretch flex-col50">
                <Button theme={'secondary'} label="Apply Filters"></Button>
              </div>
              <div className="flex-col flex-stretch flex-col50">
                <Button theme={'gray-light'} disabled={selected.length == 0} label="Clear" onClick={e => clear()}></Button>
              </div>
            </div>
          </PanelFooter>
        </StackedPanel>
      </Form>
    </Dropdown>
  </>
  
}